import { useTranslation } from "react-i18next"
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import i18n from "../../../i18n";
import { enUS, de } from 'date-fns/locale';
import {
    Box,
    IconButton,
    Tooltip,
    Typography,
} from '@mui/material';

import {
    ArrowBackIosRounded,
    ArrowForwardIosRounded,
    EventRepeat,
} from '@mui/icons-material';

import ButtonDatePicker from "../../shared/ButtonDatePicker";

function TimeKeeperCalendarToolbar( view ) {

    function CustomToolbar({ label, onNavigate, date }) {
        const { t } = useTranslation();

        const navigateToDay = () => {
            let d = new Date();
            onNavigate(null, d);
        };

        const navigateNextWeek = () => {
            let d = new Date(date);
            d.setDate(d.getDate() + 7);
            onNavigate(null, d);
        };

        const navigateLastWeek = () => {
            let d = new Date(date);
            d.setDate(d.getDate() - 7);
            onNavigate(null, d);
        };

        const navigateNextMonth = () => {
            let d = new Date(date);
            d.setMonth(d.getMonth() + 1, 1);
            onNavigate(null, d);
        };

        const navigateLastMonth = () => {
            let d = new Date(date);
            d.setMonth(d.getMonth() - 1, 1);
            onNavigate(null, d);
        };

        return (
            <>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, alignItems: 'center' }}>
                    {view === 'week' &&
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === 'de' ? de : enUS}>
                                <ButtonDatePicker
                                    value={date}
                                    onChange={(newValue) => onNavigate(null, newValue)}
                                    title={t('auswählen', { ns: 'timeKeepingPage', defaultValue: 'Datum wählen' })}
                                />
                            </LocalizationProvider>
                            <Tooltip title={t('letzteWoche', { ns: 'timeKeepingPage', defaultValue: 'Vorherige Woche' })}>
                                <IconButton size='small' onClick={navigateLastWeek}>
                                    <ArrowBackIosRounded fontSize='inherit' />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('nächsteWoche', { ns: 'timeKeepingPage', defaultValue: 'Nächste Woche' })}>
                                <IconButton size='small' onClick={navigateNextWeek}>
                                    <ArrowForwardIosRounded fontSize='inherit' />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('aktuelleWoche', { ns: 'timeKeepingPage', defaultValue: 'Aktuelle Woche' })}>
                                <IconButton size='small' onClick={navigateToDay}>
                                    <EventRepeat />
                                </IconButton>
                            </Tooltip>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {label}
                            </Typography>
                        </Box>
                    }

                    {view === 'month' &&
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={i18n.language === 'de' ? de : enUS}>
                                <ButtonDatePicker
                                    value={date}
                                    onChange={(newValue) => onNavigate(null, newValue)}
                                    title={t('auswählen', { ns: 'timeKeepingPage', defaultValue: 'Datum wählen' })}
                                />
                            </LocalizationProvider>
                            <Tooltip title={t('letzterMonat', { ns: 'timeKeepingPage', defaultValue: 'Vorheriger Monat' })}>
                                <IconButton size='small' onClick={navigateLastMonth}>
                                    <ArrowBackIosRounded fontSize='inherit' />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('nächsterMonat', { ns: 'timeKeepingPage', defaultValue: 'Nächster Monat' })}>
                                <IconButton size='small' onClick={navigateNextMonth}>
                                    <ArrowForwardIosRounded fontSize='inherit' />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={t('aktuellerMonat', { ns: 'timeKeepingPage', defaultValue: 'Aktueller Monat' })}>
                                <IconButton size='small' onClick={navigateToDay}>
                                    <EventRepeat />
                                </IconButton>
                            </Tooltip>
                            <Typography sx={{ fontWeight: 'bold' }}>
                                {label}
                            </Typography>
                        </Box>
                    }
                </Box>
            </>
        );
    };

    return CustomToolbar;
};

export default TimeKeeperCalendarToolbar
